import { useLoggedInUser } from '../../state';

/**
 * Hook to get a Refiner form URL for the current user.
 */
export function useRefinerFormURL({
    uri,
    organizationId,
    source,
    contactExtra = {},
    withResponseAccess,
}: {
    uri: string;
    organizationId?: string;
    source?: string;
    contactExtra?: { [key: string]: string };
    withResponseAccess?: boolean;
}): string {
    const user = useLoggedInUser();
    const url = new URL(uri);

    url.searchParams.set('contact_id', user.uid);

    if (user.email) {
        url.searchParams.set('contact_email', user.email);
    }

    if (organizationId) {
        url.searchParams.set('response_org_id', organizationId);
    }

    Object.entries(contactExtra).forEach(([key, value]) => {
        url.searchParams.set(`contact_${key}`, value);
    });

    if (source) {
        url.searchParams.set('response_source', source);
    }

    if (withResponseAccess) {
        url.searchParams.set('response_access', 'Yes');
    }

    return url.toString();
}
